import React from 'react';
import { Card, Typography, Box } from '@material-ui/core';
import { useGlobal } from '@rcg/ui-react';
import PropTypes from 'prop-types';
import useStyles from './index.style';
import { setPosition } from '../../commons';

const RoomInfo = (props) => {
  const {
    id,
    guests,
    stateroom: { deck, number, type, position, subType },
  } = props;
  const { renderContent } = useGlobal();
  const css = useStyles();

  const guestCount = guests.length;
  const guarantee = number === 'GTY';
  const locationLabel = renderContent(`formBookingAmend${position}`, position);
  return (
    <div className={css.root} data-testid="room-info">
      <Card className="roomInfo">
        <div className="roomInfo__wrapper">
          <Typography className="roomInfo__title" component="h1" id="days-left" variant="inherit">
            {guarantee
              ? renderContent('stateroomBookingAmendGuaranteeTitle', 'Guaranteed Stateroom')
              : subType}
          </Typography>
          <div className="roomInfo__details">
            <Box className="room-labels">
              <Typography className="room-labels__label" component="span">
                {`${guestCount} ${renderContent('stateroomBookingAmendGuestsLabel', 'Guests')}`}
              </Typography>
              {guarantee && (
                <Typography className="room-labels__label guarantee" component="span">
                  {`${type.toLowerCase()} ${renderContent(
                    'stateroomBookingAmendGuaranteeLabel',
                    'Guarantee',
                  ).toLowerCase()}`}
                </Typography>
              )}
              {!guarantee && (
                <>
                  <Typography className="room-labels__label" component="span">
                    {setPosition(locationLabel)}
                  </Typography>
                  <Typography className="room-labels__label" component="span">
                    {`${renderContent('stateroomBookingAmendDeckLabel', 'Deck')}  ${
                      guarantee ? '' : deck.code
                    }`}
                  </Typography>
                  <Typography className="room-labels__label" component="span">
                    {`${renderContent('stateroomBookingAmendRoomLabel', 'Room')} #${number}`}
                  </Typography>
                </>
              )}
            </Box>
            <div className="roomInfo__details--reservation">
              {renderContent('preferencesMenuBookingAmendReservation', `Reservation`)} #{id}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
RoomInfo.propTypes = {
  id: PropTypes.string,
  guests: PropTypes.string,
  stateroom: PropTypes.shape({
    deck: PropTypes.string,
    number: PropTypes.number,
    type: PropTypes.string,
    position: PropTypes.string,
    subType: PropTypes.string,
  }),
};

export default RoomInfo;
